import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetRevenuePerResidentRequestDtoSchema = z.object({
  facilityId: z.string(),
  from: z.string(),
  to: z.string(),
});

const GetRevenuePerResidentResponseDtoSchema = z.object({
  avgResidents: z.number().nullable(),
  avgResidentsChangePct: z.number().nullable(),
  revenuePerResident: z.number().nullable(),
  revenuePerResidentChangePct: z.number().nullable(),
  sparkline: z.object({
    granularity: z.enum(['day', 'week', 'month']),
    points: z.array(
      z.object({
        end: z.string(),
        start: z.string(),
        value: z.number().nullable(),
      })
    ),
  }),
});

export type GetRevenuePerResidentRequestDto = z.infer<
  typeof _GetRevenuePerResidentRequestDtoSchema
>;

export type GetRevenuePerResidentResponseDto = z.infer<
  typeof GetRevenuePerResidentResponseDtoSchema
>;

export const getRevenuePerResident = (
  params: GetRevenuePerResidentRequestDto,
  config?: AxiosRequestConfig<GetRevenuePerResidentRequestDto>
) => {
  const { facilityId, ...dateRange } = params;

  return api
    .get(`facilities/${facilityId}/revenue-per-resident`, {
      params: dateRange,
      ...config,
    })
    .then(responseContract(GetRevenuePerResidentResponseDtoSchema));
};
